export enum ERequestStatus {
  Failure = 'failure',
  Initial = 'initial',
  Loading = 'loading',
  Success = 'success',
}
